import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOrganisation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 2.625H.75v18.75H12zM23.25 10.875H12v10.5h11.25z"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M10.5 4.703H2.25V7.32h8.25zM10.5 10.568H2.25v2.617h8.25zM21.75 13.181H13.5v1.594h8.25zM20.25 17.58H15v3.795h5.25zM10.5 16.429H2.25v2.617h8.25zM17.625 17.591v3.773"
	})]
});
export default SvgIconOrganisation;
